import type { PickupPointBlockProps } from "./types";
import PanelContainer from "../../lib/panel/panel-container";
import PanelTranslationState from "../../lib/panel/panel-translation-state";
import { BlockPanelProps } from "../../lib/register-block";
import PanelNoSettings from "../../lib/panel/panel-no-settings";


export function PickupPointEmailPanelRenderer(blockProps: BlockPanelProps<PickupPointBlockProps>) {
  return (
    <PanelContainer blockProps={blockProps}>
      <PanelNoSettings />
      <PanelTranslationState mode="auto" portal />
    </PanelContainer>
  );
}
